module.exports = __webpack_public_path__ + "img/closed-booking-icon.85bc51c7.svg";